import { render, staticRenderFns } from "./ExternalPaidOrderBindPage.vue?vue&type=template&id=bb20e57e&scoped=true"
import script from "./ExternalPaidOrderBindPage.vue?vue&type=script&lang=js"
export * from "./ExternalPaidOrderBindPage.vue?vue&type=script&lang=js"
import style0 from "./ExternalPaidOrderBindPage.vue?vue&type=style&index=0&id=bb20e57e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb20e57e",
  null
  
)

export default component.exports